import styled from "styled-components";

export const FooterContainer = styled.footer`
	width: 100%;
	display: flex;
	padding: 12px 0;
	background-color: #f5f5f5;
	color: #2e333e;
`;

export const FooterItems = styled.div`
	width: 1280px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	display: none;
`;

export const FooterUtils = styled.div`
	font-size: 11px;
	display: flex;
	align-items: center;
`;

export const FooterGdprText = styled.span`
	text-decoration: underline;
	margin-right: 10px;
	cursor: pointer;
`;

export const FooterUtilDivide = styled.span`
	margin-right: 8px;
	padding-bottom: 5px;

	&:after {
		content: ".";
	}
`;

export const FooterYear = styled.span``;
